<template>
<div id="app">



	<div v-if="loading">
		<div class="loading-video">
			<video src="~@/assets/vid/loading-anim.mp4" autoplay loop poster="posterimage.jpg"></video>
		</div>
	</div>
	<div v-else-if="!loading">
		<HeaderTemplate v-bind:user="user" v-bind:logout="logout" />
		<SectionHeader />
		<BackerBox v-if="hasBackerBox()" v-bind:user="user" v-bind:kickstarter="kickstarter" />
		<SectionHeadline title="My products" class="forest" />
		<SectionFancyPreorder v-if="hasPreorder()" v-bind:user="user" />
		<SectionFancyWhatsIncluded v-if="hasPreorder()" />
		<SectionFancySoftware v-if="hasSoftware()" v-bind:user="user" v-bind:phase="phase" />
		<SectionUpgradeBox v-if="hasUpgrade()" v-bind:user="user" />
		<SectionFancySubscription v-if="hasSubscription()" v-bind:user="user" v-bind:kickstarter="kickstarter" />
		<SectionFancyAsset v-if="hasSubscription()" v-bind:user="user" />
		<SectionFancySettings v-if="hasSubscription()" v-bind:user="user" v-bind:phase="phase" />
		<SectionHeadline title="Timeline" class="desert" />
		<SectionTimeline />
		<SectionHeadline title="Dev Diary" class="vulcano" />
		<SectionVideo />
		<SectionVideoList />
		<FooterTemplate />

		<b-modal ref="fs_modal"
			hide-footer
			no-close-on-backdrop
			no-close-on-esc
			hide-header-close
			title="Thank you for your order!">
			<p>
				We are processing your order right now. Once this is done, you will receive a confirmation email to the email address you have provided on checkout.
			</p>
			<p>
				This can take a few minutes, so please refresh your page.
			</p>
			<p>
				If you are experiencing problems, please contact us at support@dungeonfog.com and
				tell us the order ID that was included in your payment confirmation email.
			</p>
			<div class="button-wrapper">
				<a v-on:click="makeReload()" class="button-sub">REFRESH TO UPDATE</a>
			</div>
		</b-modal>
	</div>
</div>
</template>

<script>
import FooterTemplate from './components/FooterTemplate.vue'
import HeaderTemplate from './components/HeaderTemplate.vue'
import SectionFancyPreorder from './components/SectionFancyPreorder.vue'
import SectionFancyAsset from './components/SectionFancyAsset.vue'
import SectionFancySettings from './components/SectionFancySettings.vue'
import SectionFancySoftware from './components/SectionFancySoftware.vue'
import SectionFancySubscription from './components/SectionFancySubscription.vue'
import SectionHeader from './components/SectionHeader.vue'
import SectionHeadline from './components/SectionHeadline.vue'
import BackerBox from './components/BackerBox.vue'
import SectionTimeline from './components/SectionTimeline.vue'
import SectionVideo from './components/SectionVideo.vue'
import SectionVideoList from './components/SectionVideoList.vue'
import SectionUpgradeBox from './components/SectionUpgradeBox.vue'
import SectionFancyWhatsIncluded from './components/SectionFancyWhatsIncluded.vue'

import Keycloak from 'keycloak-js';
let keycloak = null;
if (process.env.NODE_ENV === 'production') {
	keycloak = new Keycloak({
		url: 'https://auth.dungeonfog.com/auth/',
		realm: 'dungeonfog',
		clientId: 'dungeonfog',
	});
}

export default {
	name: 'App',
	components: {
		FooterTemplate,
		HeaderTemplate,
		SectionFancyPreorder,
		SectionFancyAsset,
		SectionFancySettings,
		SectionFancySoftware,
		SectionFancySubscription,
		SectionHeader,
		SectionHeadline,
		BackerBox,
		SectionTimeline,
		SectionVideo,
		SectionVideoList,
		SectionUpgradeBox,
		SectionFancyWhatsIncluded,
	},
	data: () => ({
		loading: true,
		user: {
			manage: '#',
			token: {},
		},
		phase: {
			access: [
				// "alpha-0",
				// "alpha-1",
				// "alpha-2",
				"open-beta",
				// "closed-beta"
			],
			download: [
				"windows",
				"macos",
				"linux",
			],
		},
		kickstarter: {
			current: {},
			"/Preorder": {
				name: "Preorder",
				month: 0,
				badge: ""
			},
			"/Preorder Upgrade": {
				name: "Preorder Upgrade",
				month: 12,
				badge: ""
			},
			"/Preorder Sub": {
				name: "Preorder Sub",
				month: 12,
				badge: ""
			},
			"/Basic": {
				name: "Helping Fairy",
				month: 0,
				badge: "badge_deios_helping_fairy.png"
			},
			"/Bronze": {
				name: "Bronze",
				month: 6,
				badge: "badge_deios_bronze.png"
			},
			"/Silver": {
				name: "Silver",
				month: 9,
				badge: "badge_deios_silver.png"
			},
			"/Gold": {
				name: "Gold",
				month: 15,
				badge: "badge_deios_gold.png"
			},
			"/Gold PLUS": {
				name: "Gold PLUS",
				month: 21,
				badge: "badge_deios_gold.png"
			},
			"/Platinum": {
				name: "Platinum",
				month: 27,
				badge: "badge_deios_platinum.png"
			},
			"/Platinum CL": {
				name: "Platinum CL",
				month: 27,
				badge: "badge_deios_platinum_cl.png"
			},
			"/Lifetime": {
				name: "Lifetime",
				month: "lifetime",
				badge: "badge_deios_lifetime.png"
			},
			"/Lifetime CL": {
				name: "Lifetime CL",
				month: "lifetime",
				badge: "badge_deios_lifetime_cl.png"
			},
			"/Lifetime 2017": {
				name: "Lifetime 2017",
				month: "lifetime",
				badge: "badge_deios_lifetime.png"
			},
		}
	}),

	methods: {
		hasBackerBox: function() {
			return this.user.token.groups.includes('/Kickstarter');
		},

		hasPreorder: function() {
			return this.user.token.groups.length == 0;
		},

		hasSoftware: function() {
			if (
				this.user.token.groups.includes('/Bronze') ||
				this.user.token.groups.includes('/Silver') ||
				this.user.token.groups.includes('/Gold') ||
				this.user.token.groups.includes('/Gold PLUS') ||
				this.user.token.groups.includes('/Lifetime 2017')
			) {
				return true;
			}
			if (typeof this.user.token.dungeonfog !== 'undefined') {
				return this.user.token.dungeonfog.standalone_keys > 0;
			}
			return false
		},

		hasUpgrade: function() {
			if(this.user.token.groups.includes('/Lifetime 2017')) {
				return false;
			}

			if (
				typeof this.user.token.dungeonfog === 'undefined' ||
				typeof this.user.token.dungeonfog !== 'undefined' &&
				typeof this.user.token.dungeonfog.standalone_keys === 'undefined'
			) {
				if (
					this.user.token.groups.includes('/Gold PLUS') ||
					this.user.token.groups.includes('/Gold') ||
					this.user.token.groups.includes('/Silver') ||
					this.user.token.groups.includes('/Bronze') ||
					this.user.token.groups.includes('/Basic')
				) {
					return true;
				}
			}

			if( this.user.token.groups.includes('/Preorder') ) {
				return true;
			}

			return false;
		},

		hasSubscription: function() {
			return this.user.token.groups.includes('/Preorder') ||
				this.user.token.groups.includes('/Preorder Upgrade') ||
				this.user.token.groups.includes('/Preorder Sub') ||
				this.user.token.groups.includes('/Kickstarter') ||
				this.user.token.groups.includes('/Lifetime 2017')
		},

		getKickstarterInfo: function() {
			if (this.user.token.groups.includes('/Basic')) {
				this.kickstarter.current = this.kickstarter['/Basic'];
			}
			if (this.user.token.groups.includes('/Preorder')) {
				this.kickstarter.current = this.kickstarter['/Preorder'];
			}
			if (this.user.token.groups.includes('/Preorder Upgrade')) {
				this.kickstarter.current = this.kickstarter['/Preorder Upgrade'];
			}
			if (this.user.token.groups.includes('/Preorder Sub')) {
				this.kickstarter.current = this.kickstarter['/Preorder Sub'];
			}
			if (this.user.token.groups.includes('/Bronze')) {
				this.kickstarter.current = this.kickstarter['/Bronze'];
			}
			if (this.user.token.groups.includes('/Silver')) {
				this.kickstarter.current = this.kickstarter['/Silver'];
			}
			if (this.user.token.groups.includes('/Gold')) {
				this.kickstarter.current = this.kickstarter['/Gold'];
			}
			if (this.user.token.groups.includes('/Gold PLUS')) {
				this.kickstarter.current = this.kickstarter['/Gold PLUS'];
			}
			if (this.user.token.groups.includes('/Platinum')) {
				this.kickstarter.current = this.kickstarter['/Platinum'];
			}
			if (this.user.token.groups.includes('/Platinum CL')) {
				this.kickstarter.current = this.kickstarter['/Platinum CL'];
			}
			if (this.user.token.groups.includes('/Lifetime')) {
				this.kickstarter.current = this.kickstarter['/Lifetime'];
			}
			if (this.user.token.groups.includes('/Lifetime CL')) {
				this.kickstarter.current = this.kickstarter['/Lifetime CL'];
			}
		},

		logout: () => {
			if (process.env.NODE_ENV === 'production') {
				keycloak.logout({
					redirectUri: 'https://deios.dungeonfog.com/'
				});
			}
		},

		makeReload() {
			location.reload();
		},

		fsPopupClosed(data) {
			if (!this.loading) {
				if (data.detail !== null) {
					// console.log(data.detail);
					this.$refs['fs_modal'].show();
				}
			}
		}
	},
	updated() {
		window.fastspring.builder.updateSession()
	},
	mounted() {
		this.fastspring = window.fastspring;
	},
	beforeCreate() {
		if (process.env.NODE_ENV === 'production') {
			keycloak.init({
				onLoad: 'login-required',
				promiseType: 'native',
				enableLogging: true,
			}).then(authenticated => {
				if (authenticated) {
					this.loading = false;
					this.user = {
						manage: keycloak.createAccountUrl(),
						token: keycloak.tokenParsed,
					};
					this.getKickstarterInfo();
					// console.log(JSON.stringify(this.user));
				}
			}).catch(() => alert('failed to initialize'));
		} else {
			setTimeout(() => {
				this.loading = false;
				this.user = {
					manage: '#manage',
					// token: require("../_data/live/new.json")
					// token: require("../_data/live/basic.json")
					// token: require("../_data/live/bronze.json")
					// token: require("../_data/live/gold.json")
					// token: require("../_data/live/gold-plus.json")
					// token: require("../_data/live/silver.json")
					token: require("../_data/live/platinum.json")
					// token: require("../_data/live/platinum-cl.json")
					// token: require("../_data/live/lifetime.json")
					// token: require("../_data/live/lifetime-2017.json")
					// token: require("../_data/live/basic-lifetime-2017.json")
					// token: require("../_data/live/basic-lifetime-2017-02.json")
					// token: require("../_data/live/bronze-lifetime-2017.json")
					// token: require("../_data/live/lifetime-cl.json")
					// token: require("../_data/live/new-preorder.json")
					// token: require("../_data/live/preorder-sub.json")
					// token: require("../_data/live/new-preorder-upgrade.json")
					// token: require("../_data/live/new_preorder_test_alpha1.json")
				};
				this.getKickstarterInfo();
				console.log(JSON.stringify(this.user));
			}, 1000);
		}
	},
	created() {
		addEventListener("fsPopupClosed", this.fsPopupClosed)
	},
	destroyed() {
		removeEventListener("fsPopupClosed", this.fsPopupClosed)
	}
}

window.dataPopupClosed = data => {
	dispatchEvent(new CustomEvent('fsPopupClosed', {
		detail: data
	}))
}
</script>

<style lang="css">
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,600,700,800,900&display=swap');
</style>
